import * as React from 'react'
const styles = require('./styles')
const PhoneIcon = require('assets/components/icon-phone.svg')
const EmailIcon = require('assets/components/email.svg')

interface ContactCardProps {
  profileImage: string
  name: string
  email: string
  phone: string
}

export const ContactCard: React.FC<ContactCardProps> = (props) => (
  <div className={styles.contactCardWrapper}>
    <div className={styles.talkToExpert}>
      <span>Talk to our expert - </span> <span data-testid="li-contact-name">{props.name}</span>
    </div>
    <div>
      <div>
        <div>
          <p className={styles.contactInfoHeader}>Email Us</p>
          <EmailIcon className={styles.iconWrapper} />
          <a href={`mailto:${props.email}`} data-testid="li-contact-email">
            {props.email}
          </a>
        </div>
      </div>
      <div className={styles.contactInfoWrapper}>
        <div>
          <p className={styles.contactInfoHeader}>Call Us</p>
          <PhoneIcon className={styles.iconWrapper} />
          <a href={`tel:${props.phone}`} data-testid="li-contact-phone">
            {props.phone}
          </a>
        </div>
        <img
          className={styles.contactProfileImage}
          src={props.profileImage}
          alt={props.name}
          data-testid="li-contact-avatar"
        />
      </div>
    </div>
  </div>
)
